import React from 'react';
import styles from '../../styles/Dashboard/ActivityFeed.module.css';

const ActivityFeed = () => {
  const activityData = {
    groupActions: [
      { id: 1, text: 'Olivia favorited Unit 12A', time: '1 hr ago' },
      { id: 2, text: 'Alex requested approval on Unit 7B', time: 'Yesterday' },
    ],
    newlyAdded: [
      { id: 1, text: 'Unit 9C at 75 Main Street matches your criteria', time: '2 hrs ago' },
      { id: 2, text: 'New Unit 4A at 320 Beacon Street', time: 'Today' },
    ],
    profileChanges: [
      { id: 1, text: 'Income verification completed!', time: '3 hrs ago' },
    ]
  };

  const renderSection = (title, items) => (
    <div className={styles.section}>
      <h4 className={styles.sectionTitle}>{title}</h4>
      <ul>
        {items.map(item => (
          <li key={item.id}>
            <span className={styles.activityText}>{item.text}</span>
            <span className={styles.activityTime}>{item.time}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className={styles.activityFeed}>
	  This is for Demonstration. Real Data will come later.
      {renderSection('Group Actions', activityData.groupActions)}
      {renderSection('Newly Added', activityData.newlyAdded)}
      {renderSection('Profile Changes', activityData.profileChanges)}
    </div>
  );
};

export default ActivityFeed;
